import { Injectable } from "@angular/core";
import { BaseConfig } from "../../../../shared/service/base-config.service";
import { GenericHttpService } from "../../../../shared/service/generic-http.service";
import { ConciliacaoDistribuicaoMunicipioModelView } from "../model/conciliacao-distribuicao-municipio.model";
import { Observable } from "rxjs/Observable";
import { ExportTypes } from "../../../../shared/enum/TypeExportReportEnums";

@Injectable()
export class ConciliacaoDistribuicaoMunicipioService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public consultarDistribuicaoIPVA(dtAtualizacao: Date): Observable<ConciliacaoDistribuicaoMunicipioModelView> {

    let retorno: Observable<ConciliacaoDistribuicaoMunicipioModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/ipva/ConsultaIPVA/porData?dataAtual=', dtAtualizacao.toString()), null);
    return retorno;

  }

  public  gerarRelatoriodeIpva(dtAtualizacao: Date): Observable<Blob>{
      const url = this.baseConfig.getBaseUrlApi().concat('/ipva/ConsultaIPVA/gerarExcel?dataAtual=', dtAtualizacao.toString());
      return this.http.reportIpva(url, dtAtualizacao);
    }
}


// WEBPACK FOOTER //
// ./src/app/ipva/consulta-ipva/shared/service/conciliacao-distribuicao-municipio.service.ts